var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExchange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 77.764,
    height: 80,
    viewBox: "0 0 77.764 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "exchange",
    transform: "translate(-4.611 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_2_",
    d: "M236.58,52.658a38.9,38.9,0,0,0-23.327-35.645,3.636,3.636,0,0,0-2.912,6.664,31.619,31.619,0,0,1,6.6,54.055l2.47-12.418a3.636,3.636,0,1,0-7.133-1.419L208.231,84.26a3.637,3.637,0,0,0,2.857,4.276l20.365,4.051a3.636,3.636,0,0,0,1.419-7.133l-11.153-2.218A38.912,38.912,0,0,0,236.58,52.658Z",
    transform: "translate(-154.204 -12.657)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_4_",
    d: "M24.634,31.619a3.632,3.632,0,0,0,4.276-2.857L32.961,8.4A3.636,3.636,0,0,0,30.1,4.121L9.74.07A3.636,3.636,0,1,0,8.321,7.2l11.162,2.22a38.886,38.886,0,0,0,8.455,66.222,3.636,3.636,0,0,0,2.912-6.664,31.615,31.615,0,0,1-6.6-54.051L21.778,27.343A3.636,3.636,0,0,0,24.634,31.619Z",
    transform: "translate(0 0)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80547",
    "data-name": "Path 80547",
    d: "M-6.075-19.937A4.165,4.165,0,0,0-5-17.066l3.556-1.044a1.97,1.97,0,0,1-.587-1.37c0-1.207,1.011-1.925,2.153-2.773,1.566-1.077,3.295-2.381,3.295-5.089C3.417-30.376.84-32.5-3.368-32.5a9.332,9.332,0,0,0-7.144,3.164l2.642,2.969a5.215,5.215,0,0,1,4.012-2.023c1.794,0,2.544.848,2.544,1.859,0,.979-.881,1.6-1.892,2.316C-4.51-23.264-6.075-22.188-6.075-19.937Zm0,7.242a2.674,2.674,0,0,0,2.642,2.642A2.674,2.674,0,0,0-.791-12.695a2.674,2.674,0,0,0-2.642-2.642A2.674,2.674,0,0,0-6.075-12.695Z",
    transform: "translate(47.255 61.25)",
    fill: "#02fdb1"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExchange);
export default __webpack_public_path__ + "static/media/exchange.23a15d6574195cc84a2d6990d8b03e27.svg";
export { ForwardRef as ReactComponent };